import {
  Zap,
  Play,
  Shield,
  Clock,
  Wallet,
  Globe,
  Zap as FastForward,
  Clock as InstallClock,
} from "lucide-react";
import trustpilot from "../assets/logo/trust-pilot1.svg";


export default function Home() {
  return (
    <>
      <section className="home-section bg-gradient-to-br bg-slate-50 animated-bg">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto pt-4 sm:pt-5 lg:pt-0 pb-5">
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-center">
            {/* Left content */}
            <div className="lg:col-span-7 space-y-6 lg:space-y-8">
              {/* Trustpilot floating badge */}
              <img
                src={trustpilot}
                alt="trustpilot"
                className="w-52 sm:w-64 h-auto -mb-2"
              />

              {/* Main heading with modern typography */}
              <div className="space-y-4 lg:space-y-6">
                <h1 className="text-3xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] font-black text-gray-900 leading-tight text-balance main-title">
                  Bienvenido a{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                    TVDIAMO{" "}
                  </span>
                  <br />
                  El Mejor IPTV en
                  <br /> España
                </h1>
                <div className="text-base sm:text-lg font-bold">
                  <span className="text-xl">
                    <span className="footer-logo flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" viewBox="0 0 64 64"><path fill="#ffce31" d="M2 32c0 5.9 1.7 11.4 4.6 16h50.7c2.9-4.6 4.6-10.1 4.6-16s-1.7-11.4-4.6-16H6.6C3.7 20.6 2 26.1 2 32"></path><path fill="#ed4c5c" d="M57.4 16C52.1 7.6 42.7 2 32 2S11.9 7.6 6.6 16zM6.6 48c5.3 8.4 14.7 14 25.4 14s20.1-5.6 25.4-14z"></path><path fill="#c8b100" d="M9.2 28.7h3.2v1.8H9.2zm0 13.2h3.3v1.7H9.2z"></path><path fill="#ed4c5c" d="M8.9 39.1c-.3.2-.5.4-.5.5q0 .15.3.3c.2.1.4.3.3.5q.3-.3.3-.6c0-.3-.2-.6-.4-.7"></path><path fill="#fff" d="M9.7 30.5H12v11.4H9.7z"></path><g fill="#ed4c5c"><path d="M14.4 34.7c-.5-.2-1.4-.4-2.4-.4c-.3 0-.7 0-1.1.1c-1.4.2-2.5.8-2.4 1.2L8 34.5c-.1-.5 1.1-1.1 2.6-1.4c.5-.1 1-.1 1.4-.1c1 0 1.9.1 2.4.3z"></path><path d="M9.7 36.2c-.6 0-1.1-.2-1.1-.5c0-.2.2-.5.6-.7h.6zm2.3-.9q.6.15.9.3c.1.1-.3.5-.9.8z"></path><path d="M8.2 38.4c-.1-.2.6-.6 1.5-.9c.4-.1.7-.3 1.2-.5c1.2-.5 2.2-1.2 2-1.4l.2 1.2c.1.2-.7.8-1.9 1.4c-.4.2-1.1.5-1.5.6c-.7.2-1.3.6-1.3.7z"></path></g><path fill="#c8b100" d="M30.7 28.7h3.2v1.8h-3.2zm-.1 13.2h3.3v1.7h-3.3z"></path><path fill="#ed4c5c" d="M34.2 39.1c.3.2.5.4.5.5q0 .15-.3.3c-.2.2-.4.5-.3.6q-.3-.3-.3-.6c0-.4.2-.7.4-.8"></path><path fill="#fff" d="M31.1 30.5h2.3v11.4h-2.3z"></path><g fill="#ed4c5c"><path d="M28.7 34.7c.5-.2 1.4-.4 2.4-.4c.3 0 .7 0 1.1.1c1.4.2 2.5.8 2.4 1.2l.5-1.2c.1-.5-1.1-1.1-2.6-1.4h-1.4c-1 0-1.9.1-2.4.3z"></path><path d="M33.4 36.2c.6 0 1.1-.2 1.1-.5c0-.2-.2-.5-.6-.7h-.6zm-2.3-.9q-.6.15-.9.3c-.1.1.3.5.9.8z"></path><path d="M34.9 38.4c.1-.2-.6-.6-1.5-.9c-.4-.1-.7-.3-1.2-.5c-1.2-.5-2.2-1.2-2-1.4l-.2 1.2c-.1.2.7.8 1.9 1.4c.4.2 1.1.5 1.5.6c.7.2 1.3.7 1.2.8zM21.5 22.3c1.9 0 5.8.4 7.2 1.8c-1.5 3.6-3.9 2.1-7.2 2.1c-3.2 0-5.7 1.5-7.2-2.1c1.4-1.4 5.2-1.8 7.2-1.8"></path></g><path fill="#c8b100" d="M26.4 26.3c-1.2-.7-3-.8-4.9-.8s-3.7.2-4.9.8L17 28c1.1.3 2.7.5 4.5.5s3.3-.2 4.5-.5zm1.7-4.3c-.4-.3-1.2-.6-1.9-.6c-.3 0-.6 0-.9.1c0 0-.6-.8-2-.8c-.5 0-.9.1-1.3.3v-.1c-.1-.2-.3-.4-.5-.4s-.5.3-.5.5v.1c-.4-.2-.8-.3-1.3-.3c-1.4 0-2 .9-2 .8c-.3-.1-.6-.1-.9-.1c-4.6 0-2.3 3.1-2.3 3.1l.5-.6c-1.1-1.4-.1-2.2 1.9-2.2c.3 0 .5 0 .7.1c-.7 1 .6 1.9.6 1.9l.3-.5c-.7-.5-.8-2.2 1.2-2.2c.5 0 .9.1 1.3.4c0 .1-.1 1.5-.2 1.7l.8.7l.8-.7c-.1-.3-.2-1.6-.2-1.7c.3-.2.8-.4 1.3-.4c2.1 0 2.1 1.7 1.2 2.2l.3.5s1.1-.9.6-1.9c.2 0 .5-.1.7-.1c2.4 0 2.5 1.8 1.9 2.2l.4.6c-.2 0 .9-1.4-.5-2.6"></path><path fill="#005bbf" d="M20.9 20.1c0-.3.3-.6.6-.6c.4 0 .6.3.6.6s-.3.6-.6.6s-.6-.3-.6-.6"></path><path fill="#c8b100" d="M21.3 18.4v.3H21v.3h.3v1h-.4v.3h1.2l.1-.2l-.1-.1h-.4v-1h.3v-.3h-.3v-.3z"></path><path fill="#ed4c5c" d="M21.5 28.3c-1.6 0-3-.2-4.1-.5c1.1-.3 2.5-.5 4.1-.5s3 .2 4.1.5c-1 .3-2.5.5-4.1.5"></path><path fill="#fff" d="M21.6 45.6c-1.9 0-3.7-.5-5.3-1.2c-1.2-.6-1.9-1.7-1.9-3v-4.8h14.4v4.8c0 1.3-.8 2.5-1.9 3c-1.6.8-3.4 1.2-5.3 1.2m-.1-17h7.2v8h-7.2z"></path><path fill="#ed4c5c" d="M21.6 41.4c0 1.9-1.6 3.4-3.6 3.4s-3.6-1.5-3.6-3.4v-4.8h7.2z"></path><path fill="#c8b100" d="M15.9 44.2c.2.1.5.3.9.4v-8.2H16zm-1.6-2.9c0 1 .4 1.8.8 2.2v-7.1h-.8z"></path><path fill="#c7b500" d="M17.5 44.8h.8v-8.4h-.8z"></path><path fill="#c8b100" d="M19.1 44.6c.3-.1.7-.3.9-.4v-7.8h-.8z"></path><path fill="#ed4c5c" d="M14.3 28.6h7.2v8h-7.2z"></path><path fill="#c8b100" d="M20.8 43.5c.4-.3.7-1 .8-1.8v-5.2h-.8z"></path><path fill="#ed4c5c" d="M28.8 36.6v4.8c0 1.9-1.6 3.4-3.6 3.4s-3.6-1.5-3.6-3.4v-4.8zM26.2 30c.3.6.3 2.1-.6 1.8c.2.1.3.8.6 1.2c.5.6 1.1.1 1-.6c-.2-1.1-.1-1.8.1-2.9c0 .1.5.1.7-.1c-.1.3-.2.7 0 .7c-.2.3-.7.8-.8 1.1c-.1.7 1 2-.2 2.3c-.8.2-.3.8 0 1.1c0 0-.4 1.3-.2 1.2c-.8.3-.6-.4-.6-.4c.4-1.2-.7-1.3-.6-1.5c-1-.1.1.9-.8.9c-.2 0-.6.2-.6.2c-1.1-.1-.5-1.1-.1-1c.3.1.6.6.6-.1c0 0-.5-.8.8-.8c-.5 0-.8-.4-1-.9c-.2.1-.5.6-1.6.7c0 0-.3-1.1 0-.9c.4.2.6.2 1-.2c-.2-.3-1.4-.7-1.2-1.4c0-.2.6-.5.6-.5c-.1.5.2 1 .8 1c.8.1.5-.2.6-.4s.7.1.5-.4c0-.1-.7-.2-.5-.5c.4-.5 1-.1 1.5.4m-4.6 14.6l-.2-.5l.2-.6l.2.6z"></path><path fill="#c8b100" d="M16.5 30.3v.5h.2v.4h-.5v1h.3v2.2h-.6v1.1H20v-1.1h-.5v-2.2h.2v-1h-.5v-.4h.3v-.5h-1v.5h.2v.4h-.5V30h.3v-.5h-1.1v.5h.3v1.2h-.5v-.4h.2v-.5zm11.3 12.3v-5h-5.2v5l2.4 1.1h.3zM25 38v1.7L23.3 38zm-2.1.1l2 2l-2 2zm.2 4.4l1.9-1.9v2.8zm2.2.8v-2.8l1.9 1.9zm2.1-1.2l-2-2l2-2zM25.3 38H27l-1.7 1.7z"></path><path fill="#ed4c5c" d="M19.2 36.5c0-1.5 1-2.6 2.3-2.6s2.3 1.2 2.3 2.6s-1 2.6-2.3 2.6s-2.3-1.1-2.3-2.6"></path><path fill="#005bbf" d="M19.9 36.5c0-1.1.7-1.9 1.6-1.9s1.6.9 1.6 1.9c0 1.1-.7 1.9-1.6 1.9c-.8.1-1.6-.8-1.6-1.9"></path><path fill="#c8b100" d="m20.8 35.2l-.4 1.1l.3.1l-.2.4h.6l-.2-.4l.3-.1zm1.5 0l-.4 1.1l.3.1l-.2.4h.6l-.1-.4l.3-.1zm-.7 1.3l-.5 1.1l.3.1l-.1.4h.5l-.1-.4l.3-.1z"></path></svg>
                    </span>
                  </span>
                </div>
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-700 text-balance">
                  Entretenimiento premium para{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                    tu dispositivo
                  </span>
                </h2>
              </div>

              {/* Stats cards */}
              <div className="grid grid-cols-3 gap-2 sm:gap-4">
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#04003b]">
                    79K+
                  </div>
                  <div className="text-xs text-gray-600 font-medium">
                    Canales
                  </div>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#090979]">
                    249K+
                  </div>
                  <div className="text-xs text-gray-600 font-medium">VOD</div>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center border border-white/20 shadow-lg">
                  <div className="text-lg sm:text-2xl font-black text-[#00d4ff]">
                    4K
                  </div>
                  <div className="text-xs text-gray-600 font-medium">
                    Calidad
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <button className="bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transition-all duration-500 flex items-center justify-center gap-2 sm:gap-3 min-h-[48px]">
                  <Zap className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span className="text-sm sm:text-base">
                    Activación Inmediata
                  </span>
                </button>
                <a
                  href="#premium-basico"
                  className="bg-white/90 backdrop-blur-sm hover:bg-white text-gray-900 border border-gray-200/50 px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transition-all min-h-[48px] flex items-center justify-center"
                >
                  <span className="text-sm sm:text-base">
                    Pedir - 29€/año
                  </span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-4 lg:space-y-6">
              <div className="relative">
                {/* Main feature card */}
                <div className="bg-gradient-to-br from-white to-blue-50/50 border-0 shadow-2xl rounded-2xl sm:rounded-3xl overflow-hidden">
                  <div className="p-6 sm:p-8">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#04003b] via-[#090979] to-[#00d4ff] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg">
                      <Play className="w-6 h-6 sm:w-8 sm:h-8 text-white fill-white" />
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                      Streaming Premium
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                      Disfruta de una calidad de imagen 4K en cualquier
                      dispositivo con una disponibilidad del 100% y la activación
                      gratuita de IBO Pro Player.
                    </p>
                    <button 
                        onClick={() => {
                          const element = document.getElementById("pricing");
                          if (element) {
                              element.scrollIntoView({ behavior: "smooth" });
                          }
                        }}
                     className="w-full bg-[#090979] hover:bg-[#0a0a61] text-white rounded-lg sm:rounded-xl font-semibold shadow-lg py-2.5 sm:py-3 transition-colors text-sm sm:text-base min-h-[44px]">
                      Todos los Planes
                    </button>
                  </div>
                </div>

                {/* Floating mini cards */}
                <div className="absolute -right-2 sm:-right-4 -top-2 sm:-top-4 bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl border border-white/20">
                  <Shield className="w-4 h-4 sm:w-6 sm:h-6 text-[#00d4ff] mb-1 sm:mb-2" />
                  <div className="text-xs font-bold text-gray-900">
                    Reembolso
                  </div>
                  <div className="text-xs text-gray-600">Garantía</div>
                </div>

                <div className="absolute -left-2 sm:-left-4 -bottom-[10%] sm:-bottom-[15%] bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xl border border-white/20">
                  <Clock className="w-4 h-4 sm:w-6 sm:h-6 text-[#090979] mb-1 sm:mb-2" />
                  <div className="text-xs font-bold text-gray-900">0.5s</div>
                  <div className="text-xs text-gray-600">
                    Tiempo de carga
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12  sm:mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-4 mb-8 sm:mb-10">
            {/* Garantie de Remboursement */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <Wallet className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Garantía de Reembolso
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  No estás satisfecho con tu suscripción IPTV? ¡No te
                  preocupes! Ofrecemos una garantía de reembolso de
                  15 días para un reembolso completo.
                </p>
              </div>
            </div>

            {/* 79.000+ Chaînes */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <Globe className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  79.000+ Canales de Todo el Mundo
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  Accede a 79.000 canales de TV y 249.000 películas y series,
                  incluyendo una amplia selección de canales europeos.
                </p>
              </div>
            </div>

            {/* Connexion Ultra Rapide */}
            <div className="group hover:shadow-2xl hover:brightness-110 hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <FastForward className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Conexión Ultra Rápida
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  TVDIAMO utiliza un servidor dedicado europeo de alta calidad,
                  permitiendo que los canales de TV se carguen en 0,5 segundos -
                  sin retrasos ni interrupciones.
                </p>
              </div>
            </div>

            {/* Installation Immédiate */}
            <div className="group hover:shadow-2xl hover:scale-105 transition-all duration-300 bg-gradient-to-r from-[#04003b] to-[#00d4ff] backdrop-blur-sm border-0 shadow-xl rounded-2xl sm:rounded-3xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex items-center justify-center lg:justify-start mb-4 sm:mb-6">
                  <InstallClock className="w-6 h-6 sm:w-8 sm:h-8 text-slate-50" />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-50 mb-3 sm:mb-4 text-center lg:text-left">
                  Instalación Inmediata
                </h3>
                <p className="text-slate-100 leading-relaxed text-center lg:text-left text-sm sm:text-base">
                  Instala tu suscripción IPTV directamente en cualquier
                  dispositivo. Ofrecemos una instalación remota gratuita y
                  la activación de IBO Pro Player, sin costos ocultos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
